import {Pressable, Text, View} from "react-native";
import React from "react";

import {styles} from "./styles";
import {i18n} from "./localization";
import {BaseModal} from "./BaseModal";

export const InfoModal = ({visible, onPressClose, text, isError}) => {
    return (
        <BaseModal visible={visible} onPressClose={onPressClose}>
            {isError ?
                <>
                    <Text style={styles.errorModal.modalHeader}>
                        {i18n.t("error")}
                    </Text>
                        <Text style={styles.baseModal.modalText}>
                            {text ? text : i18n.t("smthWrong")}
                        </Text>
                </>
                :
                <>
                    <Text style={styles.baseModal.modalText}>
                        {text ? text : "Ok"}
                    </Text>
                </>
            }
            <View style={{width: "100%"}}>
                <Pressable onPress={onPressClose} style={styles.button}>
                    <Text style={styles.buttonText}>{i18n.t("close")}</Text>
                </Pressable>
            </View>
        </BaseModal>
    )
}
